<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <b-col>
                        <lg-form-input-finder v-model="form.descricao" fieldDescription="Descrição:" description=""
                            label="Descrição:" :showClearButton="false">
                        </lg-form-input-finder>
                    </b-col>
                    <b-col cols="4" class="d-flex align-items-center justify-content-around">
                        <b-button id="localizar-ibp-almoxarifado" class="ml-3 mr-2 my-2" size="sm" style="height: 20px"
                            pill variant="primary" @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizar-ibp-almoxarifado" title="Localizar"></b-tooltip>
                        </b-button>


                        <b-button id="limpar-ibp-almoxarifado" class="my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limpar-ibp-almoxarifado" title="Limpar"></b-tooltip>
                        </b-button>

                    </b-col>
                </b-form-row>
                <b-form-row @keyup.enter="load">
                    <b-col cols="12" lg="8">
                        <LgFinderPageAlmoxarifado id="finderAlmoxarifado" @onselect="handleSelectAlmoxarifado"
                            v-model="form.almoxarifado" :prefix="prefix + title + ' > '" />
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <lg-form-input-finder v-model="form.tombamentoDe" fieldDescription="Descrição:" description=""
                        label="Tombamento:" :showClearButton="false" cols="4">
                    </lg-form-input-finder>
                    <lg-form-input-finder v-model="form.tombamentoAte" fieldDescription="Descrição:" description=""
                        label="Até:" :showClearButton="false" cols="4">
                    </lg-form-input-finder>
                </b-form-row>
                <b-form-row class="justify-content-center">
                    <b-button
                        :disabled="(!this.records || this.records.length == 0) || (!this.itensParaEnviar || this.itensParaEnviar.length == 0)"
                        :id="prefix + title + 'transferir'" size="xl" @click="transferir" variant="dark">
                        <b-icon icon="arrow-left-right" scale="1.2" />
                        Transferir itens selecionados para o Depósito
                    </b-button>
                </b-form-row>

                <b-table responsive class="mt-3" small :busy="this.busy" :items="this.records"
                    :fields="PermanenteFields" hover show-empty>

                    <template #head(selecao)>
                        <b-form-checkbox
                            v-if="temPrivilegioTransferirDepartamento() || temPrivilegioTransferirPatrimonio()"
                            :value="true" :unchecked-value="false" @change="marcarTodosAceito"
                            v-model="todosMarcados"></b-form-checkbox>
                    </template>

                    <template #cell(selecao)="row">
                        <b-form-checkbox
                            v-if="busy === false && (temPrivilegioTransferirDepartamento() || temPrivilegioTransferirPatrimonio())"
                            :value="true" :unchecked-value="false" @change="onSelectAceito(row.item, true)"
                            v-model="row.item.selecao"></b-form-checkbox>

                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>

                <div class="d-flex justify-content-end mt-2"
                    v-if="temPrivilegioTransferirDepartamento() || temPrivilegioTransferirPatrimonio()">
                    <span>{{
                        `Total de itens selecionados: ${this.itensParaEnviar.length}`
                    }}</span>
                </div>


            </b-card>
        </b-card-body>
    </b-card>
</template>
<script>
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import ResourceService from "@/core/api/ResourceService"
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import LgFinderPageAlmoxarifado from "../../../components/Finders/LgFinderPageAlmoxarifado.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
    components: {
        LgFormInputFinder,
        LgFinderPageAlmoxarifado,
    },

    mixins: [ListResourceMixin, FormResourceMixin],

    props: {
        prefix: {
            type: String,
            default: "Itens Almoxarifado",
        },
        title: {
            type: String,
            default: "",
        },
    },

    data() {
        return {
            departamento: {},
            itensParaEnviar: [],
            todosMarcados: false,
            busy: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            form: {
                descricao: "",
                almoxarifado: {},
                tombamentoDe: "",
                tombamentoAte: "",
            },
        }
    },

    computed: {
        PermanenteFields() {
            return [
                { key: "selecao", label: " ", thClass: "w-10", tdClass: "w-10" },
                { key: "numTombamento", label: "Tombamento" },
                { key: "numero", label: "Número" },
                { key: "descricaoResumida", label: "Descrição" },
                { key: "almoxarifado", label: "Almoxarifado" },
                { key: "valorOriginal", label: "Valor" },
            ]
        },
    },
    beforeMount() {

        this.$service = new ResourceService("/api/itembempermanente")

    },

    mounted() {
        this.load()
    },

    watch: {
        page() {
            this.load();
        },

        form: {
            handler() {
                this.load()
            },
            deep: true,
        },
    },

    methods: {
        temPrivilegioTransferirPatrimonio() {
            return verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_CONSUMO_TRANSF_PATRIMONIO);

        },
        temPrivilegioTransferirDepartamento() {
            return verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_CONSUMO_TRANSF_DEPART);

        },

        onSelectAceito(bem, marcarTodos) {

            if (marcarTodos)
                this.todosMarcados = this.records && this.records.every(ibp => ibp.selecao);

            if (bem.selecao) {

                const idxAdd = this.itensParaEnviar.findIndex(
                    ibp => ibp === bem.id
                );

                if (idxAdd == -1)
                    this.itensParaEnviar.push(bem.id);

            } else {

                const idxRemove = this.itensParaEnviar.findIndex(
                    ibp => ibp === bem.id
                );

                if (idxRemove != -1)
                    this.itensParaEnviar.splice(idxRemove, 1);

            }

        },
        marcarTodosAceito(valor) {
            this.busy = true;
            this.todosMarcados = valor;
            this.records.forEach(item => {
                item.selecao = this.todosMarcados;
                this.onSelectAceito(item, false);
            }
            )
            this.busy = false;




        },
        async load() {
            let filtro = {}


            filtro.isAbaItensAlmoxarifado = true;
            if (this.form.descricao && this.form.descricao != "") {
                filtro.descricao = this.form.descricao
            }
            if (this.form && this.form.almoxarifado.id) {
                filtro.almoxarifado = this.form.almoxarifado.id
            }
            if (this.form.tombamentoDe) {
                filtro.tombamentoDe = this.form.tombamentoDe
            }
            if (this.form.tombamentoAte) {
                filtro.tombamentoAte = this.form.tombamentoAte
            }
            this.busy = true;
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            });

            if (this.hasRecords())
                this.records.forEach(bem =>
                    bem.selecao = this.itensParaEnviar.findIndex(
                        ibp => ibp === bem.id
                    ) != -1);

            this.todosMarcados = this.records && this.records.every(ibp => ibp.selecao);

        },

        hasRecords() {
            return Array.isArray(this.records) && this.records.length > 0
        },


        handleSelectAlmoxarifado(almoxarifado) {
            this.form.almoxarifado = almoxarifado
            this.load();
        },


        clearForm() {
            this.form = {
                descricao: "",
                almoxarifado: {},
                tombamentoDe: "",
                tombamentoAte: "",
            }
            this.load();
        },

        async transferir() {
            try {
                this.busy = true;
                await this.$service.put("movimentar", this.itensParaEnviar
                );
                this.busy = false;
                this.$notify({
                    type: "success",
                    message: "Itens movimentado com sucesso",
                });
                this.load();
            } catch (error) {
                this.busy = false;
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });
            }

        }
    },
}
</script>
